import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const wholesalerCode = async (code?: string) =>
  axios.get(Routes.WHOLESALER + "/" + code);

export const useWholesalerCode = (code?: string) =>
  useQuery({
    queryKey: [Keys.WHOLESALER_QRY, code],
    queryFn: () => wholesalerCode(code),
    enabled: false,
  });
